import {Component} from '@angular/core';
import {AbstractEditExpertSearchFieldValue} from '../abstract-edit-expert-search-field-value';

@Component({
  selector: 'app-search-management-edit-number-edit-expert-search-field-value',
  templateUrl: './number-edit-expert-search-field-value.component.html'
})
export class SearchManagementNumberEditExpertSearchFieldValueComponent extends AbstractEditExpertSearchFieldValue {

  public onKeyUp(event): void {
    this.onChange.emit({
      value: this.field.fieldValue,
      labelValue: this.field.fieldValue
    });
  }

  public onSpinnerChange(event): void {
    this.onChange.emit({
      value: this.field.fieldValue,
      labelValue: this.field.fieldValue
    });
  }
}
